import type { Tracker } from 'usage-tracker-core';

export const primaryTrackers = new Map<string, Tracker>();
